export default "__VITE_ASSET__C_k2k1Wi__"